import React from 'react';
import Numpad from '../../../numpad/Numpad';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../../../store/spirs/types";
import {SET_RATE_COUPON, SET_RATE_COUPON_EVENT, UPDATE_COUPON_MESSAGE} from "../../../../store/spirs/actions";
import * as Popover from '@radix-ui/react-popover';
import clsx from "clsx";
import {Desktop} from "../../../adaptive/Desktop";

interface StepPopover {
    maxStepValue: number | null
    minStepValue: number | null
    stepValue: string
    selectionId?: number
}

function StepPopover(props: StepPopover) {
    const {stepValue: v, maxStepValue, minStepValue} = props;
    const [stepValue, setValue] = React.useState(v);
    const isEmpty = stepValue === '0';
    const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);
    const {balance, web} = useSelector((state: StoreType) => state.spirs.playerInfo);
    const coupons = useSelector((state: StoreType) => state.spirs.coupons);
    const currentCouponType = useSelector((state: StoreType) => state.spirs.coupons.currentCouponType);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    React.useEffect(() => {
        setValue(props.stepValue)
    }, [props.stepValue])

    React.useEffect(() => {

        const getRate = (): number => {
            switch (currentCouponType) {
                case 'SYSTEM':
                    const activeEvents = coupons[currentCouponType].filter(el => el.active);
                    return coupons.rate[currentCouponType] * activeEvents.length;
                case 'ORDINAR':
                case 'EXPRESS':
                    return coupons.rate[currentCouponType];
            }
        };

        if (minStepValue && balance && (Number.parseInt(stepValue) < minStepValue && balance >= Number.parseInt(stepValue))) {
            if (getRate() == 0) return;
            dispatch(UPDATE_COUPON_MESSAGE(t('coupons.existMessage') + String(' ' + minStepValue)));
        }

    }, [stepValue]);

    function handleClick(event: React.MouseEvent) {
        if (web) return;

    }

    function closeNumpad() {

    }

    function addDigit(digit: string) {
        const digits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
        if (
            !(stepValue.length === 0 && digit === '0') &&
            digits.includes(digit)
        ) {
            let newValue = Number.parseInt(stepValue + digit);
            if (maxStepValue && (newValue > maxStepValue)) {
                setStepValue(maxStepValue);
            } else {
                setStepValue(newValue);
            }
        }
    }

    function delDigit() {
        if (stepValue.length > 1) {
            setStepValue(Number(stepValue.slice(0, -1)));
        } else if (stepValue.length === 1) {
            setStepValue(0);
        }
    }

    function resetValue() {
        setStepValue(0);
    }

    function setMaxStepValue() {
        if (!maxStepValue) return;
        setStepValue(maxStepValue);
    }

    /**
     * <h6>Преобразование любого вида дробного числа, в целочисленное значение,
     * методом отсекания дробной части.</h6>
     * <p><i>Пример: 99.9 -> 99; 99,99 -> 99</i></p>
     * @param value Строковое значение размера шага
     */
    const floatStringToInt = (value: string) => {
        // Если вводимая строка пустая, то возвращается NaN
        // Значение выбрано для совместимости с возвращаемым типом number
        if (value.length < 1) {
            return NaN;
        }
        return Math.floor(parseFloat(value.replace(',', '.')));
    };

    function handleChange({target: {value}}: React.ChangeEvent<HTMLInputElement>) {
        // Разрешаем очистку
        if (value === '') {
            setStepValue(0);
            return;
        }
        if ((stepValue.length === 0 && value === '0') || value.length > 15 || isNaN(floatStringToInt(value))) {
            return;
        }
        const newValue = floatStringToInt(value);
        if (maxStepValue && (newValue > maxStepValue)) {
            setStepValue(maxStepValue);
        } else {
            setStepValue(newValue);
        }
    }

    function setStepValue(newValue: number) {
        setValue(newValue.toString());
        if (props.selectionId) {
            dispatch(SET_RATE_COUPON_EVENT(props.selectionId, newValue));
        } else {
            dispatch(SET_RATE_COUPON(newValue));
        }
    }

    function addDigitOnKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Backspace') {
            delDigit();
        }
        addDigit(event.key);
    }

    return (
        <Popover.Root>
            <Popover.Trigger asChild>
                <div className="desktop:text-[16px]">
                    <input
                        className={clsx(
                            "text-[12px] font-['Roboto'] leading-[100%] desktop:text-[16px] h-[30px] desktop:h-[40px] hover:bg-[#C4C9DO] rounded-[8px] placeholder-[#565656] text-center",
                            isEmpty ? "text-[#565656] bg-[#989FA4]" : "text-black bg-white",
                        )}
                        placeholder={t(`coupons.numPad.${currentCouponType === 'SYSTEM' ? 'placeholderSystem' : 'placeholder'}`)}
                        value={stepValue === '0' ? '' : stepValue}
                        onChange={handleChange}
                    />
                </div>
            </Popover.Trigger>
            {!web && <Popover.Portal>
                <Popover.Content sideOffset={5}>
                    <Desktop>
                        <Numpad
                            addDigit={addDigit}
                            delDigit={delDigit}
                            resetValue={resetValue}
                            setMaxStepValue={setMaxStepValue}
                            closeNumpad={closeNumpad}
                        />
                    </Desktop>
                </Popover.Content>
            </Popover.Portal>}
        </Popover.Root>
    );
}

export default StepPopover;
